import { Slider } from "@/components/ui/slider";
import { usedWeights } from "@/lib/library";

const LABELS = { personality: "Personality & work style", scenarios: "Workplace Scenarios", quiz: "Skills Quiz & scored custom questions" };

export function ScoringStep({ t, set, canEdit, data }) {
  const used = usedWeights(t.sections);
  const keys = Object.keys(LABELS).filter((k) => used[k]);
  const total = keys.reduce((a, k) => a + (t.weights[k] || 0), 0);
  const setW = (k, v) => set({ weights: { ...t.weights, [k]: v } });
  const even = () => set({ weights: Object.fromEntries(Object.keys(LABELS).map((k) => [k, used[k] ? Math.floor(100 / keys.length) + (k === keys[0] ? 100 % keys.length : 0) : 0])) });
  return (
    <div className="grid gap-4 lg:grid-cols-[2fr_1fr]" data-testid="builder-scoring">
      <section className="panel space-y-5 p-6">
        <div><h2 className="text-lg font-semibold">How much each section counts</h2>
          <p className="text-sm text-ink-secondary">The overall assessment score is a weighted average of the sections below.</p></div>
        {!keys.length && <p className="text-sm text-ink-muted">Add a section first.</p>}
        {keys.map((k) => (
          <div key={k} className="space-y-2">
            <div className="flex justify-between text-sm"><span>{LABELS[k]}</span><span className="font-display font-semibold tabular-nums" data-testid={`weight-value-${k}`}>{t.weights[k] || 0}%</span></div>
            <Slider value={[t.weights[k] || 0]} max={100} step={5} disabled={!canEdit} onValueChange={([v]) => setW(k, v)} aria-label={`${LABELS[k]} weight`} data-testid={`weight-${k}`} />
          </div>
        ))}
        <div className="flex items-center gap-3 text-sm">
          <span className={total === 100 ? "text-success" : "text-caution"} role="status" data-testid="weight-total">Total {total}%{total !== 100 && " · must add up to 100%"}</span>
          {canEdit && keys.length > 0 && <button className="text-primary underline-offset-2 hover:underline" onClick={even} data-testid="weight-even">Split evenly</button>}
        </div>
        {data?.warnings?.length > 0 && (
          <ul className="list-disc space-y-1 rounded-[6px] border border-[#E8D7B0] bg-caution-tint p-3 pl-7 text-sm" data-testid="scoring-warnings">
            {data.warnings.map((w) => <li key={w}>{w}</li>)}</ul>
        )}
      </section>
      <aside className="panel space-y-2 p-5 text-sm text-ink-secondary" data-testid="scoring-explainer">
        <h3 className="font-semibold text-ink">How answers are scored</h3>
        <p><b>Answers with a key</b> (one or several correct, yes/no) are marked automatically. Several-correct questions give partial credit and take points off for wrong picks.</p>
        <p><b>Short and long answers</b> marked as scored are compared with your model answer by meaning. Each score shows the reason and the matching part of the answer.</p>
        <p><b>Personality</b> is scored by fixed rules against published norms. It is never marked right or wrong.</p>
        <p>Reviewers make the final decision. Scores are a guide.</p>
      </aside>
    </div>
  );
}
